import { Badge, DropdownButton } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import InfoIconTooltip from "app/pages/sales-intelligence/common-components/tooltip/InfoIconTooltip/InfoIconTooltip";

import {
    StyledCellContainer,
    StyledDropdown,
    StyledDropdownItem,
    StyledDropdownWrapper,
    StyledExample,
    StyledValue,
} from "../styles";

import {
    CRM_EXPORT_DROPDOWN_HEIGHT,
    CRM_EXPORT_DROPDOWN_WIDTH,
    SIMILARWEB_CELL_PLACEHOLDER,
    SIMILARWEB_FIELD,
} from "./constants";
import type { SimilarwebCellPropsType } from "./types";

export const SimilarwebCell = ({
    onClick,
    searchFilter,
    title,
    isRequired,
    similarwebFields,
    setting,
    exportName,
    placement = "ontop-left",
    index,
}: SimilarwebCellPropsType) => {
    const handleClick = (newSetting: { id: string; text: string }) => onClick(setting, newSetting);

    const appendClass = `similarweb-dropdown-${exportName}-${index}`;

    return (
        <StyledCellContainer className={appendClass}>
            <StyledDropdownWrapper>
                <StyledDropdown
                    hasSearch
                    dropdownPopupHeight={CRM_EXPORT_DROPDOWN_HEIGHT}
                    width={CRM_EXPORT_DROPDOWN_WIDTH}
                    dropdownPopupPlacement={placement}
                    appendTo={`.${appendClass}`}
                    searchPlaceHolder={translate(SIMILARWEB_CELL_PLACEHOLDER)}
                    disabled={isRequired}
                    onClick={handleClick}
                    searchFilter={searchFilter}
                >
                    {[
                        <DropdownButton
                            key={`${SIMILARWEB_FIELD}-button`}
                            disabled={isRequired}
                        >
                            {title}
                        </DropdownButton>,
                        ...similarwebFields.map(({ example, name, field, badgeType, tooltipKey }) => {
                            return (
                                <StyledDropdownItem
                                    text={name}
                                    key={`${SIMILARWEB_FIELD}-${name}`}
                                    id={field}
                                    infoText={
                                        <Flex
                                            gap="4px"
                                            alignItems="center"
                                            justifyContent="space-between"
                                        >
                                            <Box
                                                flex="1"
                                                minWidth="0"
                                            >
                                                <StyledValue>{name}</StyledValue>
                                                {example ? <StyledExample>(E.g. {example})</StyledExample> : null}
                                            </Box>

                                            <Flex
                                                gap="4px"
                                                alignItems="center"
                                            >
                                                {tooltipKey ? <InfoIconTooltip tooltipKey={tooltipKey} /> : null}
                                                {badgeType ? <Badge type={badgeType} /> : null}
                                            </Flex>
                                        </Flex>
                                    }
                                />
                            );
                        }),
                    ]}
                </StyledDropdown>
            </StyledDropdownWrapper>
        </StyledCellContainer>
    );
};
